export default "__VITE_ASSET__D_pI3UCC__"